import React, { Component } from 'react';
import {Link} from "react-router-dom";

import "./../styles/ventanaDecisionStyle.css";

export default class VentanaGuia extends Component {
    render() {
        return (
            <div className="VentanaDecision" id="VentanaGuia">
                <div className="card card-800">
                    <div className="header-card">
                        <Link to="/" className="tranqui-logo">Tranqui</Link>
                    </div>
                    <div className="body-card">
                      <div className="info-card">
                        {this.props.contenido}
                      </div>
                    </div>
                    <div className="end-card">
                        <Link onClick={window.scrollTo(0,0)} to={this.props.anterior} className="btnSelect" style={{padding: "10px 20px", marginRight: "15px", fontSize: "16px"}}>Anterior</Link>
                        <Link onClick={window.scrollTo(0,0)} to={this.props.siguiente} className="btnSelect" style={{flexDirection: "row-reverse", padding: "10px 20px", fontSize: "16px"}}>Siguiente</Link>
                    </div>
                </div>
            </div>
        )
    }
}
